/**
 * Created by Reda 15.09.2026
 */

class ForegroundSceneComponent extends BaseComponent {
    apply() {
        const json = cleverapps.skins.getSlot("gameSceneFg");
        if (!json) {
            return;
        }

        if (json instanceof VirtualJson && !cleverapps.bundleLoader.isLoaded(json.bundleName)) {
            return;
        }

        if (!this.foreground) {
            this.foreground = new cleverapps.Spine(json);
            this.foreground.setAnimation(0, "animation", true);
            this.foreground.setLocalZOrder(this.options.zOrder);
            this.node.addChild(this.foreground);
        }

        const bgRect = cleverapps.resolution.getBgRect();
        const contentSize = this.foreground.getContentSize();

        const scale = Math.max(bgRect.width / contentSize.width, bgRect.height / contentSize.height);
        this.foreground.setScale(scale + (scale * 0.05));
        this.foreground.setPosition(bgRect.x + bgRect.width / 2, bgRect.y + bgRect.height / 2);
    }

    onSceneLoaded() {
        this.apply();
    }

    onResize() {
        this.apply();
    }
}

Prefab.registerComponent("ForegroundSceneComponent", {}, ForegroundSceneComponent);
